import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { User } from '../../shared/classes/user';

@Injectable()
export class ContactService {

  constructor(private http: Http) { }

  getContacts(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.contactsUrl}`, options)
      .map(res => res.json())
  }

  addContact(orgId: number, user: User) {
    let data = { contact: user, commit: 'Complete' };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.contactsUrl}`, data, options)
      .map(res => res.json())
  }

  editContact(orgId: number, id: number, user: User) {
    let data = { contact: user, commit: 'Complete', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/contacts/${id}.json`, data, options)
      .map(res => res.json())
  }

  deleteContact(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/contacts/${id}.json`, options)
      .map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/contact.service.ts